import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base/base.service';
import { AlexFeedbackModel } from 'src/app/settings/models/alex.model';

@Injectable({
  providedIn: 'root',
})
export class AlexService extends BaseService {

  private readonly urlPrefix = `${environment.maintenance.urlPrefix}/alex`;
  constructor(http: HttpClient) {
    super(http);
  }

  addFeedback(alexFeedbckModel: AlexFeedbackModel) {
    return this.post<any>(`${this.urlPrefix}/feed-back`, alexFeedbckModel);
  }

}
